module.exports = __webpack_public_path__ + "static/media/error.9a9b9eca.svg";